<template>
    <ui-data-table 
        :p-headers="headers"
        p-title="Propagandas"
        p-read-link="adverts.read.one"
        p-create-link="adverts.create"
        p-name="adverts"
    />
</template>
<script>

import {uiDataTable} from '@/components/ui'
export default {
    name: 'vwAdvertsRead',
    components: {
        uiDataTable  
    },
    data(){
        return {
            headers: [{
                text: 'id',
                value: 'id'
            }, {
                text: 'Nome',
                value: 'nome'
            }, {
                text: 'Ativa',
                value: 'ativo'
            }, {
                text: 'Inicio',
                value: 'inicio'
            }, {
                text: 'Fim',
                value: 'fim'
            }, {
                text: 'Cadastrado',
                value: 'criado_em'
            }, {
                text: 'Ações', 
                value: 'actions', 
                sortable: false
            }],
        }
    },
}
</script>